
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NuxtLinkButton',
  props: {
    buttonType: {
      type: String,
      default: 'primary'
    },
    to: {
      type: String,
      required: true
    }
  },
  computed: {
    colors(): string {
      const colorTypeMap: Record<string, string> = {
        primary: 'text-ink-400 bg-juniper hover:bg-juniper-600',
        secondary: 'text-vanilla-100 bg-ink-300 hover:bg-ink-200'
      }
      return colorTypeMap[this.buttonType]
    }
  }
})
